export enum ZahlungListColumn {
  Checkbox = 'checkbox',
  Status = 'zahlungsstatus',
  Empfaenger = 'empfaenger',
  Faelligkeitsdatum = 'faelligkeitsdatum',
  Ausfuehrungsdatum = 'ausfuehrungsdatum',
  Verwendungszweck = 'verwendungszweck',
  Zahlbetrag = 'zahlbetrag',
  Erstellt = 'erstellt',
  Iban = 'iban',
  Bic = 'bic',
  Bank = 'bank',
  Aktion = 'aktion',
}
